// extracted by mini-css-extract-plugin
export var cardIcon = "_6k-5";
export var cardIconUnframed = "_6k-9";
export var checkboxCard = "_6k-0";
export var checkboxCardSelected = "_6k-4";
export var disabled = "_6k-2";
export var interactive = "_6k-1";
export var outerBorder = "_6k-3";
export var spacerMedium = "_6k-8";
export var spacerSmall = "_6k-7";
export var spacerXsmall = "_6k-6";